import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {RegistrationUpdateStatusStore} from './types';

export const useRegistrationUpdateStatusStore = create<RegistrationUpdateStatusStore>()(
	persist(
		set => ({
			needsUpdate: false,
			setNeedsUpdate: value => set({needsUpdate: value}),
			isDrawerDismissed: false,
			dismissDrawer: () => set({isDrawerDismissed: true}),
			resetRegistrationUpdateStore: () =>
				set({
					needsUpdate: false,
					isDrawerDismissed: false,
				}),
		}),
		{
			name: 'registrationUpdateStatusStorage',
			partialize: state => ({
				needsUpdate: state.needsUpdate,
				isDrawerDismissed: state.isDrawerDismissed,
			}),
		},
	),
);
